var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('v-breadcrumbs',{staticClass:"app-breadcrumb-header pa-0",attrs:{"items":_vm.items,"divider":"›"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }